import { Component, OnInit } from '@angular/core';
import { IonFab, ModalController, NavParams } from '@ionic/angular';
import { Util } from '../../../util/util';

@Component({
    selector: 'modal-popover',
    templateUrl: 'modal-popover-component.html',
    styleUrls: ['modal-popover-component.scss']
})

export class ModalPopoverComponent implements OnInit {

    listahistorico: any;

    constructor(private modalController: ModalController,
                private navParams: NavParams,) {
        this.listahistorico = this.navParams.get('listahistorico');
    }


    ngOnInit() {
    }

    getTextFormat(text) {
        return Util.getTextFormat(text);
    }

    selectFilter(item) {
        this.modalController.dismiss({filtro: item});
    }

    fechar() {
        this.modalController.dismiss();
    }
}
